import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import SubHeader from './SubHeader';
import BusinessChallenge from './BusinessChallenge';
import Personas from './Personas';
import MilestoneBuilder from './MilestoneBuilder';
import EnablementCards from '../Entry/EnablementCards';
import { Icon } from '@salesforce/design-system-react';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

const Sidebar = (props) => {
    const [businessChallengeScore, setBusinessChallengeScore] = useState(0);
    const [personaScore, setPeronaScore] = useState(0);
    const [milestoneScore, setMilestoneScore] = useState(0);
    const [productOverlaysScore, setProductOverlaysScore] = useState(0);

    const [businessChallengeOpen, setBusinessChallengeOpen] = useState(false);
    const [personasOpen, setPersonasOpen] = useState(false);
    const [milestoneConnectorOpen, setMilestoneConnectorOpen] = useState(false);

    const [percentage, setPercentage] = useState(0);
    const [steps, setSteps] = useState(0);


    useEffect(() => {
        let bcValue = 0, pValue = 0, mValue = 0, poValue = 0;
    
        if(props.companyGoal !== '' && props.companyGoal !== undefined)
            bcValue += 25;
        if(props.measureOne !== '' && props.measureOne !== undefined)
            bcValue += 25;
        if(props.measureTwo !== '' && props.measureTwo !== undefined)
            bcValue += 25;
        if(props.measureThree !== '' && props.measureThree !== undefined)
            bcValue += 25;

        setBusinessChallengeScore(bcValue);

        if(Object.keys(props.personas).length === 1)
            pValue = 50;
        else if(Object.keys(props.personas).length > 1)
            pValue = 100;

        setPeronaScore(pValue);

        if(props.milestones.trigger.content !== '' && props.milestones.trigger.content !== undefined)
            mValue += 20;
        if(props.milestones.guide.content !== '' && props.milestones.guide.content !== undefined)
            mValue += 20;
        if(props.milestones.key.content !== '' && props.milestones.key.content !== undefined)
            mValue += 20;
        if(props.milestones.crisis.content !== '' && props.milestones.crisis.content !== undefined)
            mValue += 20;
        if(props.milestones.triumph.content !== '' && props.milestones.triumph.content !== undefined)
            mValue += 20;

        setMilestoneScore(mValue);

        if(props.journeyCompleted === true){
            poValue = 100;

            setProductOverlaysScore(100)
        }
        
        setPercentage(Math.round((bcValue + pValue + mValue + poValue) / 4))

        setSteps((bcValue / 25) + (pValue / 50) + (mValue / 20) + (poValue / 100));
    }, []);
    

    return (
        <div className="sidebar slds-p-top_x-small slds-p-bottom_medium">
            <div className="slds-p-bottom_medium" style={{ height: '9%'}}>
                <div 
                    className="slds-p-bottom_small slds-align_absolute-center" 
                    style={{ color: "white", fontSize: "1.6rem"}}
                    
                >
                    <a href="/" style={{ color: 'white', textDecoration: 'none' }}>HERO6</a>
                </div> 
                <div 
                    className="slds-text-title_caps slds-align_absolute-center" 
                    style={{ color: "white", fontSize: '.6rem' }}
                >
                    <div className="slds-grid" >
                        <div className="slds-col">
                            <a
                                href="https://app.slack.com/client/T01GST6QY0G/C01TMUM3PFG"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: 'white'}}
                            >
                            Provide Feedback
                            </a>
                        </div>
                        <div className="slds-col slds-p-horizontal_x-small">|</div>
                        <div className="slds-col">
                            <a
                                href="https://app.slack.com/client/T01GST6QY0G/C01TRKWTBNZ"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: 'white'}}
                            >
                            Report A Bug
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div 
                className="slds-p-horizontal_small"
                style={{ height: '7%', color: 'white', overflowY: 'scroll', borderTop: '1px solid #eee', borderBottom: '1px solid #eee'}}
            >
                <div className="slds-p-vertical_x-small">
                    {props.instructions}
                    <EnablementCards stage={props.stage} />
                </div>
            </div>
            <div style={{ color: '#fff'}}>
                <div className="slds-align_absolute-center slds-p-vertical_small" 
                    style={{ fontSize: '1rem', height: '7%', fontWeight: '600'}}
                >Journey Summary</div>
            </div>
            <div className="slds-align_absolute-center slds-p-vertical_medium" style={{ width: "41%", height: '14.5%'}}>
                <CircularProgressbar
                    value={percentage}
                    text={<tspan dx={true ? -25 : 0} dy={true ? 6 : 0}>{percentage}%</tspan>}
                    styles={buildStyles({
                        strokeLinecap: 'round',
                        textSize: '20px',
                        pathTransitionDuration: 0.5,
                        pathColor: `rgba(75, 202, 129, 1)`,
                        textColor: '#4bca81',
                        trailColor: '#f6f6f6',
                        backgroundColor: '#3e98c7',
                    })}
                />
            </div>
            <div 
                style={{ height: "61%", overflowY: 'scroll'}}
                className="slds-p-top_x-large"
            >
                <div>
                    <SubHeader
                        isOpen={false}
                        setIsOpen={() => {}}
                        score={0}
                        title="Home"
                        redirectUrl="/"
                        expand={false}
                    />
                </div>
                <div 
                    style={businessChallengeOpen ? ({ backgroundColor: "#4A80C1" }) : null }
                >
                    <SubHeader
                        isOpen={businessChallengeOpen}
                        setIsOpen={setBusinessChallengeOpen}
                        score={businessChallengeScore}
                        title="Business Challenge"
                        redirectUrl="/BusinessChallenge"
                    />
                    { businessChallengeOpen ? (
                        <BusinessChallenge />
                    ) : (null)}
                </div>

                <div 
                    style={personasOpen ? ({ backgroundColor: "#4A80C1" }) : null }
                >
                    <SubHeader
                        isOpen={personasOpen}
                        setIsOpen={setPersonasOpen}
                        score={personaScore}
                        title="Personas"
                        redirectUrl="/Personas"
                    />
                    { personasOpen ? (
                        <Personas />
                    ) : (null)}
                </div>

                <div>
                    <SubHeader
                        isOpen={false}
                        setIsOpen={() => {}}
                        score={milestoneScore}
                        title="Milestones"
                        redirectUrl="/Milestones"
                        expand={false}
                    />
                </div>

                <div 
                    style={milestoneConnectorOpen ? ({ backgroundColor: "#4A80C1" }) : null }
                >
                    <SubHeader
                        isOpen={milestoneConnectorOpen}
                        setIsOpen={setMilestoneConnectorOpen}
                        score={milestoneScore}
                        title="Milestone Connectors"
                        redirectUrl="/MilestoneConnectors"
                    />
                    { milestoneConnectorOpen ? (
                        <div style={{ 
                            height: '100%',
                            position: 'fixed',
                            top: '0',
                            left: '15%',
                            bottom: '0',
                            width: '15%',
                            backgroundColor: '#fefefe',
                            boxShadow: '1px 1px 1px 0px #d3d3d3',
                            overflowY: 'scroll'
                        }}>
                            <MilestoneBuilder 
                                setMilestoneOpen={setMilestoneConnectorOpen}
                            />
                        </div>
                    ) : (null)}
                </div>
                <div>
                    <SubHeader
                        isOpen={false}
                        setIsOpen={() => {}}
                        score={productOverlaysScore}
                        title="Salesforce Products"
                        redirectUrl="/ProductsOverlay"
                        expand={false}
                    />
                </div>
            </div>
            <div 
                className="slds-align_absolute-center" 
                style={{ fontSize: '.8rem', color: 'white', color: 'white', borderTop: '1px solid #eee', height: '5%'}}
            ><span className="slds-p-right_small"><Icon category="utility" name="user" size="x-small" style={{ fill: '#fff'}} /></span> <strong>{props.username}</strong></div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    username: state.app.username,
    journeyName: state.app.journeyName,
    journeyCompleted: state.app.journeyCompleted,
    companyGoal: state.businessChallenge.companyGoal,
    measureOne: state.businessChallenge.measureOne,
    measureTwo: state.businessChallenge.measureTwo,
    measureThree: state.businessChallenge.measureThree,
    personas: state.personas,
    milestones: state.milestones,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Sidebar);